<div class="d-flex justify-content-center align-items-center pt-5 flex-column">
  <span class="alert alert-info d-flex justify-content-center align-items-center grid-gap-05rem">
    <fa-icon icon="info-circle"></fa-icon>
    <div>Vous n'avez accès à aucune application sur le Portail client Libriciel.</div>
  </span>
  <button class="btn btn-primary" (click)="logout()">Se déconnecter</button>
</div>
